import { render, staticRenderFns } from "./TeacherLicense.vue?vue&type=template&id=140e51bf"
import script from "./TeacherLicense.vue?vue&type=script&lang=js"
export * from "./TeacherLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports